// GSTINs are always exactly 15 characters (alphanumeric). Anything else —
// missing, blank, placeholder text, or a truncated/malformed number — means
// this outlet is not GST-registered for billing purposes, so GST must not
// be shown on any bill for it. Mirrors utils/gstValidation.js in the
// FootOrder backend, which applies the same rule to order calculations.
export const isValidGstNumber = (gstNumber) =>
  typeof gstNumber === "string" && gstNumber.trim().length === 15;
